import React, { useEffect, useState } from 'react';
import api from '@src/api/axiosInstance';

type Details = {
 status: 'unique'|'shared'|'unmatched'|'stale';
 client_url?: string;
 pets_total?: number;
 pets: {id:string;name:string;species:string;url:string}[];
};
export default function WakymaDetails({waId}:{waId:string}) {
 const [data,setData]=useState<Details>();
 const [failed,setFailed]=useState(false);
 useEffect(()=>{
  const controller=new AbortController();setData(undefined);setFailed(false);
  api.get(`/wakyma/${encodeURIComponent(waId)}/`,{signal:controller.signal})
   .then(r=>{if(!controller.signal.aborted)setData(r.data);})
   .catch(()=>{if(!controller.signal.aborted)setFailed(true);});
  return ()=>controller.abort();
 },[waId]);
 if(failed)return <p role="status">No se ha podido consultar la ficha de Wakyma.</p>;
 if(!data)return <p role="status">Cargando mascotas…</p>;
 if(data.status!=='unique')return <p role="status" style={{fontSize:13,color:'#666'}}>{data.status==='shared'?'Número compartido por varios clientes. Confirma la identidad en Wakyma antes de consultar sus mascotas.':data.status==='stale'?'La lista de Wakyma no está actualizada. No mostramos fichas hasta actualizarla.':'Sin coincidencia única con un cliente activo de Wakyma.'}</p>;
 return <section aria-label="Ficha y mascotas de Wakyma" style={{marginTop:12,marginBottom:20}}>
  <a href={data.client_url} target="_blank" rel="noopener noreferrer" style={{display:'flex',alignItems:'center',justifyContent:'center',gap:10,marginBottom:22}}>
   <img src="/wakyma-logo.svg" alt="Wakyma" style={{width:72,height:24,objectFit:'contain'}}/>
   <span>Ficha Wakyma ↗</span>
  </a>
  <h4 style={{margin:'0 0 8px'}}>Mascotas <span style={{fontWeight:400,color:'#777'}}>({data.pets_total})</span></h4>
  {data.pets.length===0?<p style={{fontSize:13,color:'#666'}}>No hay mascotas activas en la lista de Wakyma.</p>:<ul style={{listStyle:'none',margin:0,padding:0}}>
   {data.pets.map(p=><li key={p.id} style={{borderBottom:'1px solid #eee'}}>
    <a href={p.url} target="_blank" rel="noopener noreferrer" style={{display:'flex',alignItems:'center',gap:12,padding:'10px 0',textDecoration:'none'}}>
     <span aria-label={p.species==='perro'?'Perro':p.species==='gato'?'Gato':'Mascota'} style={{fontSize:23}}>{p.species==='perro'?'🐶':p.species==='gato'?'🐱':'🐾'}</span>
     <span style={{flex:1,overflowWrap:'anywhere'}}>{p.name}</span><span aria-hidden="true">↗</span>
    </a>
   </li>)}
  </ul>}
  {(data.pets_total??0)>10&&<a href={data.client_url} target="_blank" rel="noopener noreferrer" style={{display:'block',marginTop:12,fontSize:13}}>Ver todas en Wakyma ({data.pets_total}) ↗</a>}
 </section>;
}
